/**
 * Calculate the page parameter for the current canvas(es)
 *
 * @param canvasIds the IDs of all canvases
 * @param visibleCanvasIds the IDs of the visible canvases
 * @param viewType the current view type
 */
const calculatePageParamFromCanvases = (
  canvasIds: string[],
  visibleCanvasIds: string[],
  viewType: string
): string | undefined => {
  const canvasIndices = visibleCanvasIds.map((c) => canvasIds.indexOf(c) + 1)
  if (viewType === 'single') {
    return `${canvasIndices[0]}`
  } else if (canvasIndices.length === 1) {
    return canvasIndices[0] > 1
      ? `${canvasIndices[0]},`
      : `,${canvasIndices[0]}`
  } else if (viewType === 'book') {
    return canvasIndices.join(',')
  }
}

export { calculatePageParamFromCanvases }
